module.exports = __webpack_public_path__ + "img/every2.1751fe03.svg";